import React from 'react'
import { Box } from '@mui/material'
import Header from './Header'
import Footer from './Footer'

const LandingLayout = ({ children }) => {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            <Footer />
        </Box>
    )
}

export default LandingLayout
